export default __webpack_public_path__ + "static/media/loader1.e86eb641.jpg";